import React, { useEffect, useRef } from 'react';
import { Edit3, Trash2, MoveUp } from 'lucide-react';

const ContextMenu = ({ 
  isOpen, 
  position, 
  onClose, 
  onRename, 
  onDelete, 
  onCollapse,
  itemName = 'item',
  itemType = 'item' // 'project', 'collection', or 'file'
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEscape);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleRename = () => {
    onRename();
    onClose();
  };

  const handleDelete = () => {
    onDelete();
    onClose();
  };

  const handleCollapse = () => {
    onCollapse();
    onClose();
  };

  return (
    <div 
      ref={menuRef}
      className="fixed z-50 bg-[#151415] border border-[#494646] rounded-lg shadow-xl py-2 min-w-[160px]"
      style={{
        left: position.x,
        top: position.y
      }}
    >
      <div className="px-3 py-1 text-xs text-slate-500 border-b border-slate-700 mb-1">
        {itemName.length > 20 ? `${itemName.substring(0, 20)}...` : itemName}
      </div>
      
      {itemType !== 'file' && (
        <button
          onClick={handleRename}
          className="w-full px-3 py-2 text-left flex items-center gap-2 text-slate-300 hover:bg-slate-700 hover:text-slate-100 transition-colors"
        >
          <Edit3 size={14} className="text-blue-400" />
          <span>Rename {itemType}</span>
        </button>
      )}
      
      {itemType === 'collection' && onCollapse && (
        <button
          onClick={handleCollapse}
          className="w-full px-3 py-2 text-left flex items-center gap-2 text-slate-300 hover:bg-slate-700 hover:text-slate-100 transition-colors"
        >
          <MoveUp size={14} className="text-yellow-400" />
          <span>Collapse collection</span>
        </button>
      )}
      
      <button
        onClick={handleDelete}
        className="w-full px-3 py-2 text-left flex items-center gap-2 text-red-400 hover:bg-red-900/20 hover:text-red-300 transition-colors"
      >
        <Trash2 size={14} />
        <span>Delete {itemType}</span>
      </button>
    </div>
  );
};

export default ContextMenu;